import { IMissionActionProps } from './types';
import VueRouter from 'vue-router';
import { axiosClient } from '~/common/js/axios';
import { verifyKycByErrorCode } from '~/common/js/helper';
import { verifyAuthorizeCode } from '~/frontend-shared/helper/util';

const domain_env = import.meta.env.VITE_DOMAIN_ENV;

// 后续用到继续补充
export enum MissionRuleEnum {
  REGISTER = 1, // 注册
  DEPOSIT = 2, // 交易
  TRADE = 3, // 充值
  OPEN_CONTRACT_ACCOUNT = 4,
  MARGIN_FIRST_EXCHANGE = 5,
  EARN_FIRST_EXCHANGE = 6,
  NFT_FIRST_EXCHANGE = 7,
  OPEN_MARGIN_ACCOUNT = 8,
  CONTRACT_TOTAL_EXCHANGE = 9,
  NFT = 10, // NFT
  PREDECESSOR = 11,
  IMPORT = 12,
  INVITE_AND_EXCHANGE = 13, // 邀请并交易
  SPOT_TOTAL_EXCHANGE = 14, // 现货累计交易
  EARN_TOTAL_EXCHANGE = 15, // 理财累计申购
  FIAT_TOTAL_RECHARGE = 16, // 法币累计充值
  SPOT_SYMBOL_TOTAL_EXCHANGE = 17, // 现货交易对累计交易
  QUALIFICATION = 18, // 资格任务
}
export const ExcludeLoginMissionRuleList = [MissionRuleEnum.REGISTER];

export const MissionRuleMap = {
  [MissionRuleEnum.INVITE_AND_EXCHANGE]: {
    actionI18nKey: 'mission-center.invite_now',
  },
  [MissionRuleEnum.SPOT_TOTAL_EXCHANGE]: {
    actionI18nKey: 'mission-center.trade_now',
  },
  [MissionRuleEnum.EARN_TOTAL_EXCHANGE]: {
    actionI18nKey: 'mission-center.subscribe_now',
  },
  [MissionRuleEnum.FIAT_TOTAL_RECHARGE]: {
    actionI18nKey: 'mission-center.deposit_now',
  },
};

const ClassTypeMap: any = {
  1001: 'classA',
  1002: 'classB',
  1003: 'classC',
};

// 跳转法币
export const gotoBuySell = (router: VueRouter, locale: string, isApp: boolean) => {
  // todo app
  // if (isApp) {
  //   window.location.href = 'bitmart://otc'
  //   return
  // }
  router.push(`/buy-sell/${locale}`);
};

// 跳转理财
export const gotoEarn = (router: VueRouter, locale: string, isApp: boolean) => {
  if (isApp) {
    window.location.href = 'bitmart://earn';
    return;
  }
  router.push(`/earn/${locale}`);
};

// 跳转现货交易
export const gotoTrade = (router: VueRouter, locale: string, isApp: boolean) => {
  if (isApp) {
    window.jsBridge.invoke('toSpotTrade');
    return;
  }
  router.push(`/trade/${locale}`);
};

// 跳转邀请
export const gotoInvite = (router: VueRouter, locale: string, inviteCode: string, isApp: boolean) => {
  if (isApp) {
    window.jsBridge.invoke('referral', {
      inviteCode,
    });
    return;
  }

  router.push(`/referral/${locale}`);
};

// 跳转nft资产页
export const gotoNftAsset = (router: VueRouter, locale: string) => {
  router.push(`/nft/${locale}/usercenter?type=ASSETS`);
};

// 跳转市场页
export const gotoNftMarket = (router: VueRouter, locale: string, collectibleId: string | number) => {
  router.push(`/nft/${locale}/collectible?collectibleId=${collectibleId}`);
};

const queryString = (str: string) => {
  if (!str) {
    return {};
  }
  let params = str.split('?')[1]; //截取?号后的字符串即name=itclanCoder&study=css
  if (!params) {
    return {};
  }
  let param = params.split('&'); // 通过&符号进行分割即["name=itclanCoder", "study=css"]
  let obj: any = {}; // 用一个对象存储目标值
  for (let i = 0; i < param.length; i++) {
    // 循环遍历截取出来的param数组
    let paramsA = param[i].split('='); // 通过split,=继续对数组params每一项进行分割,生成数组["name", "itclanCoder"]
    let key = paramsA[0]; // 取数组项["name", "itclanCoder"]中第0位,即name
    let value = paramsA[1]; // 取数组项["name", "itclanCoder"]中第1位,即itclanCoder
    obj[key] = value;
  }
  return obj;
};

const CheckOptions: any = {
  pass: {
    errCode: 0,
  },
  passWithLimit: {
    errCode: 0,
  },
  needKyc1: {
    errCode: 33135,
    bizType: 10,
  },
  needKyc2: {
    errCode: 33136,
    bizType: 11,
  },
  qrCode: {
    errCode: 33138,
  },
  forbidden: {
    errCode: -1,
  },
};

export const isNeedProgressBar = (missionRule: MissionRuleEnum) => {
  const needProgressBarList = [
    MissionRuleEnum.NFT,
    MissionRuleEnum.CONTRACT_TOTAL_EXCHANGE,
    MissionRuleEnum.SPOT_TOTAL_EXCHANGE,
    MissionRuleEnum.EARN_TOTAL_EXCHANGE,
    MissionRuleEnum.FIAT_TOTAL_RECHARGE,
    MissionRuleEnum.SPOT_SYMBOL_TOTAL_EXCHANGE,
  ];
  return needProgressBarList.includes(missionRule);
};
export const useMissionAction = ({ data, disabled = false }: IMissionActionProps) => {
  const route = useRoute();
  const store: any = useStore();
  const storeCommit = (commitName: string) => {
    if (!commitName) {
      return;
    }
    // PASS("pass", "放行"),
    // PASS_WITH_LIMIT("passWithLimit", "有限制放行"),
    // NEED_KYC1("needKyc1", "需要去做 kyc1"),
    // NEED_KYC2("needKyc2", "需要去做 kyc2"),
    // QRCODE("qrCode", "需要去扫码授权"),
    // FORBIDDEN("forbidden", "禁止"),
    if (CheckOptions[commitName]) {
      const checkOption = CheckOptions[commitName];
      const errCode = checkOption.errCode;
      if (!verifyKycByErrorCode(store, checkOption.errCode, { bizType: checkOption.bizType })) {
        return;
      }
      verifyAuthorizeCode(store, errCode, {
        callback: () => {},
      });
      return;
    }

    store.commit(commitName);
  };
  const jsBridge = (name: string, query: Object) => {
    if (name.startsWith('bitmart://')) {
      window.location.href = name;
      return;
    }
    window.jsBridge.invoke(name, query || {});
  };
  // 任务是否需要进度条
  const needProgressBar = computed(() => {
    return isNeedProgressBar(+data?.missionRule);
  });
  const link = computed(() => {
    return linkFormat(data);
  });
  // 跳转动作
  const linkFormat = (data: any) => {
    // 是否在APP内
    const isApp = process.client ? !!window.jsBridge : false;
    // 本地语言
    const locale = store.state.locale;
    // 任务系列Id
    const collectibleId = data?.collectibleId;
    // 任务规则
    const rule = data?.missionRule;
    // 任务资格
    const userCheckBizResult = data?.userCheckBizResult;
    // 当前路由是否隐藏了app navtive导航
    const isNoNavigateBar = route.value.query?.appConfig === 'noNavigateBar';
    /**** 针对规则「现货交易对累计交易」--- START ****/
    // 自定义交易对类型 - 第一个交易对
    let symbolObj;
    // 费率类型文本
    let classTypeStr;
    if (rule === MissionRuleEnum.SPOT_SYMBOL_TOTAL_EXCHANGE) {
      // 现货交易对累计交易 -- 特殊处理
      if (data.symbolIds && data.symbolIds.length > 0) {
        symbolObj = data.symbolIds[0];
      } else if (data.classType) {
        classTypeStr = ClassTypeMap[data.classType];
      }
    }
    /**** 针对规则「现货交易对累计交易」--- END ****/

    // 根据不同端「WEB、APP」、不同任务规则 - 对应不同的跳转动作
    const missionRuleMap: any = {
      web: {
        1: `/register/${locale}`, //注册 : register
        2: `StoreCommit:SHOW_DEPOSIT_GUID`, //首次充值 : deposit
        3: `/trade/${locale}`, //现货首次交易 : trade
        4: `${process.env.DERIVATIVES_HOST}/${locale}?coinType=USD`, //合约开户 : OPEN_CONTRACT_ACCOUNT
        5: `/trade/${locale}?layout=pro&symbol=BTC_USDT&type=margin`, //杠杆首次交易 : MARGIN_FIRST_EXCHANGE
        6: `/earn/${locale}`, //理财首次交易 : EARN_FIRST_EXCHANGE
        7: `/nft/${locale}/home`, //NFT首次交易 : NFT_FIRST_EXCHANGE
        8: `/trade/${locale}?layout=pro&symbol=BTC_USDT&type=margin`, //杠杆开户 : OPEN_MARGIN_ACCOUNT
        9: `${process.env.DERIVATIVES_HOST}/${locale}?coinType=USD`, //合约累计交易 : CONTRACT_TOTAL_EXCHANGE
        10: collectibleId ? `/nft/${locale}/collectible?collectibleId=${collectibleId}` : `/nft/${locale}/home`, //持有NFT系列 : NFT_FIRST_EXCHANGE
        [MissionRuleEnum.INVITE_AND_EXCHANGE]: `/referral/${locale}`,
        [MissionRuleEnum.SPOT_TOTAL_EXCHANGE]: `/trade/${locale}`,
        [MissionRuleEnum.EARN_TOTAL_EXCHANGE]: `/earn/${locale}`,
        [MissionRuleEnum.FIAT_TOTAL_RECHARGE]: `/buy-sell/${locale}`,
        [MissionRuleEnum.SPOT_SYMBOL_TOTAL_EXCHANGE]: symbolObj
          ? `/trade/${locale}?layout=pro&symbol=${symbolObj.symbol}`
          : `/fee/${locale}?class=${classTypeStr}`,
        [MissionRuleEnum.QUALIFICATION]: `StoreCommit:${userCheckBizResult}`,
      },
      app: {
        1: `k_welcome_sign_up`, //注册 : register
        2: `k_welcome_deposit`, //首次充值 : deposit
        3: `toSpotTrade`, //现货首次交易 : trade
        4: `toContractTrade`, //合约开户 : OPEN_CONTRACT_ACCOUNT
        5: `toLeverTrade`, //杠杆首次交易 : MARGIN_FIRST_EXCHANGE
        6: `earn`, //理财首次交易 : EARN_FIRST_EXCHANGE
        7: `/nft/${locale}/home`, //NFT首次交易 : NFT_FIRST_EXCHANGE
        8: `toLeverTrade`, //杠杆开户 : OPEN_MARGIN_ACCOUNT
        9: `toContractTrade`, //合约累计交易 : CONTRACT_TOTAL_EXCHANGE
        10: collectibleId ? `/nft/${locale}/collectible?collectibleId=${collectibleId}` : `/nft/${locale}/home`, //持有NFT系列 : NFT_FIRST_EXCHANGE
        [MissionRuleEnum.INVITE_AND_EXCHANGE]: `referral?inviteCode=${store.state.account.userIntroNo}`,
        [MissionRuleEnum.SPOT_TOTAL_EXCHANGE]: 'toSpotTrade',
        [MissionRuleEnum.EARN_TOTAL_EXCHANGE]: 'earn',
        [MissionRuleEnum.FIAT_TOTAL_RECHARGE]: `/buy-sell/${locale}`,
        [MissionRuleEnum.SPOT_SYMBOL_TOTAL_EXCHANGE]: symbolObj
          ? `bitmart://spot?symbolId=${symbolObj.id}`
          : `/fee/${locale}?class=${classTypeStr}${isNoNavigateBar ? '&showNav=1' : ''}`,
        [MissionRuleEnum.QUALIFICATION]: `StoreCommit:${userCheckBizResult}`,
      },
    };
    // 根据跳转动作转化构建跳转对象方法
    const transformUrlType = function (url: string) {
      if (!url) {
        return {
          disabled,
          isApp,
          content: url,
          type: rule ? (url?.indexOf('http') === 0 ? 'out' : 'in') : '',
        };
      }
      if (url.startsWith('StoreCommit:')) {
        return {
          disabled,
          isApp,
          content: url.split(':')[1],
          type: 'StoreCommit',
        };
      } else if (!url.startsWith('/') && !url.startsWith('http://') && !url.startsWith('https://')) {
        // JsBridge 方式「包含schema 方式」
        let content = url.split('?')?.[0];
        if (url?.startsWith('bitmart://')) {
          content = url;
        }
        const query = queryString(url);
        return {
          disabled,
          isApp,
          type: 'JsBridge',
          content,
          query,
        };
      }
      return {
        disabled,
        isApp,
        content: url,
        type: rule ? (url?.indexOf('http') === 0 ? 'out' : 'in') : '',
      };
    };
    const url = rule ? missionRuleMap[isApp ? 'app' : 'web'][rule] : '';
    return transformUrlType(url);
  };

  return {
    link,
    linkFormat,
    storeCommit,
    jsBridge,
    needProgressBar,
  };
};

export const handleLotteryResp = (lotteryRes: any, store: any, inApp: boolean) => {
  // todo 后期优化 copy from rewards-hub
  let luckDrawState = '';
  let luckyData = {};
  const luckyDataTemp = {
    awardType: lotteryRes.data?.awardType,
    state: lotteryRes.data?.state,
  };
  if (lotteryRes.data?.awardType === 1 || lotteryRes.data?.awardType === 0) {
    luckDrawState = 'notWin';
  } else if (lotteryRes.data?.awardType === 3 && lotteryRes.data?.state === 3) {
    luckDrawState = 'getSome';
    luckyData = {
      ...luckyDataTemp,
      quantity: lotteryRes.data.quantity,
      awardBizName: lotteryRes.data.awardBizName,
    };
  } else if (lotteryRes.data?.awardType === 3 && lotteryRes.data?.state === 4) {
    luckDrawState = 'got';
    luckyData = {
      ...luckyDataTemp,
      quantity: lotteryRes.data.quantity,
      awardBizName: lotteryRes.data.awardBizName,
      isFuturesBonus: true,
    };
  } else if (lotteryRes.data?.awardType === 4) {
    // nft 奖励
    luckDrawState = 'got';
    luckyData = {
      ...luckyDataTemp,
      quantity: lotteryRes.data.quantity,
      awardBizName: `${lotteryRes?.data?.awardBizName} NFT`,
      isFuturesBonus: false,
      goLink: `/nft/${store.state.locale}/usercenter?type=ASSETS`,
    };
  } else if (lotteryRes.data?.awardType === 5) {
    // 现货手续费返现券
    luckDrawState = 'got';
    luckyData = {
      ...luckyDataTemp,
      quantity: lotteryRes.data.quantity,
      awardBizName: lotteryRes.data.awardBizName,
      goLink: inApp ? 'bitmart://toVoucherCenter' : `/voucher-center/${store.state.locale}`,
      awardInfo: lotteryRes.data.awardInfo,
    };
  } else {
    luckDrawState = 'got';
    luckyData = {
      ...luckyDataTemp,
      quantity: lotteryRes.data.quantity,
      awardBizName: lotteryRes.data.awardBizName,
    };
  }
  return {
    luckDrawState,
    luckyData,
  };
};

export const useCountryCode = () => {
  const getCountryCode = async (store: any) => {
    // countryCode 异步问题 临时解决方案
    let countryCodeLocal = store.state?.userCountryCode || store.userCountryCode;
    if (!countryCodeLocal) {
      const res = await axiosClient({
        method: 'get',
        url:
          domain_env !== 'production' && sessionStorage?.getItem('mockIP')
            ? 'https://yapi.bitmartpro.com/mock/151/user-center/current-ip'
            : '/gw-api/user-center/current-ip',
      });
      if (res?.success) {
        const { countryCode } = res.data;
        countryCodeLocal = countryCode;
        if (countryCode && countryCode !== '') {
          store.commit ? store.commit('SET_COUNTRY_CODE', countryCode) : store.SET_COUNTRY_CODE(countryCode);
        }
      }
    }
    return countryCodeLocal;
  };
  return {
    getCountryCode,
  };
};
